import { parseDate } from "types/utils";

export const ACCESS_TOKEN_EXPIRES_AT = "__accessTokenExpiresAt";
export const REFRESH_TOKEN_EXPIRES_AT = "__RefreshTokenExpiresAt";
/** Unix ms; shared across tabs for idle timeout. */
export const LAST_USER_ACTIVITY_AT = "__lastUserActivityAt";

export const hasValidToken = (): boolean => {
    const accessTokenExpiration = getAccessTokenExpiresAt();
    const refreshTokenExpiration = getRefreshTokenExpiresAt();
    return (
        expiresInSeconds(accessTokenExpiration) > 0 ||
        expiresInSeconds(refreshTokenExpiration) > 0
    );
};

export const clearTokenExpiration = () => {
    localStorage.removeItem(ACCESS_TOKEN_EXPIRES_AT);
    localStorage.removeItem(REFRESH_TOKEN_EXPIRES_AT);
    localStorage.removeItem(LAST_USER_ACTIVITY_AT);
};

export const getLastUserActivityAt = (): number | null => {
    const raw = localStorage.getItem(LAST_USER_ACTIVITY_AT);
    if (raw === null) {
        return null;
    }
    const n = Number(raw);
    return Number.isFinite(n) ? n : null;
};

export const setLastUserActivityAt = (timestampMs: number) => {
    localStorage.setItem(LAST_USER_ACTIVITY_AT, String(timestampMs));
};

export const setAccessTokenExpiresAt = (expiresAt: string) => {
    localStorage.setItem(ACCESS_TOKEN_EXPIRES_AT, expiresAt);
};

export const getAccessTokenExpiresAt = (): Date | null => {
    const accessTokenExpiresAt = localStorage.getItem(ACCESS_TOKEN_EXPIRES_AT);
    return accessTokenExpiresAt ? parseDate(accessTokenExpiresAt) : null;
};

export const setRefreshTokenExpiresAt = (expiresAt: string) => {
    localStorage.setItem(REFRESH_TOKEN_EXPIRES_AT, expiresAt);
};

export const getRefreshTokenExpiresAt = (): Date | null => {
    const refreshTokenExpiresAt = localStorage.getItem(
        REFRESH_TOKEN_EXPIRES_AT,
    );
    return refreshTokenExpiresAt ? parseDate(refreshTokenExpiresAt) : null;
};

export const expiresInSeconds = (expirationDate: Date | null) => {
    if (!expirationDate) return 0;
    const expiresInMilliseconds =
        expirationDate.getTime() - new Date().getTime();
    return Math.round(expiresInMilliseconds / 1000);
};
